<div class="ibox detailed-view-ibox" *ngIf="amenitiesService.showDetailedView && amenitiesService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">
            Booking ID: {{amenitiesService.selectedItemData.bookingNumber}}
        </div>
        <span class="close-detailed-view" (click)="amenitiesService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm" *ngIf="amenitiesService.selectedItemData"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <div class="detailed-view-navigation">
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section" (click)="navPosition = 'info';"
                             [ngClass]="{'active': navPosition == 'info'}">
                            Info
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section" (click)="navPosition = 'payment';"
                             [ngClass]="{'active': navPosition == 'payment'}">
                            Payment
                        </div>
                    </div>
                    <!--<div class="col-md-4 col-sm-4 col-xs-4 no-padding">-->
                        <!--<div class="button-section" (click)="navPosition = 'history';"-->
                             <!--[ngClass]="{'active': navPosition == 'history'}">-->
                            <!--History-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
                <div *ngIf="navPosition == 'info'" class="content">
                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Booking ID</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span>{{amenitiesService.selectedItemData.bookingNumber || '-'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Status</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span *ngIf="amenitiesService.selectedItemData.status === 'approved'"
                                  class="label label-approved">
                                Approved
                            </span>
                            <span *ngIf="amenitiesService.selectedItemData.status === 'pending'"
                                  class="label label-pending">
                                Pending
                            </span>
                            <span *ngIf="amenitiesService.selectedItemData.status === 'expired'"
                                  class="label label-expired">
                                Expired
                            </span>
                            <span *ngIf="amenitiesService.selectedItemData.status === 'declined'"
                                  class="label label-declined">
                                Declined
                            </span>
                        </div>
                    </div>

                    <div class="row m-b-xs"
                         (dblclick)="turnEditMode(true)"
                         *ngIf="amenitiesService.selectedItemData.uses">
                        <div class="dv-label col-md-4">
                            <label>Uses</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!amenitiesService.selectedItemData.formFields.uses.editMode">
                            {{amenitiesService.selectedItemData.uses}}
                            <i *ngIf="amenitiesService.selectedItemData.isCanEdit && amenitiesService.selectedItemData.status == 'pending'"
                               class="fa fa-pencil pull-right"
                               (click)="turnEditMode(true)"
                               data-toggle="tooltip"
                               data-placement="top"
                               title="Edit">
                            </i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="amenitiesService.selectedItemData.formFields.uses.editMode">
                            <select class="form-control" [ngModel]="amenitiesService.selectedItemData.uses" name="uses">
                                <option value="" hidden></option>
                                <option [value]="use" *ngFor="let use of amenitiesService.selectedItemData.amenity.uses">
                                    {{use}}
                                </option>
                            </select>
                            <button type="button"
                                    (click)="applyChanges(amenitiesService.selectedItemData, form, {uses: form.value.uses}, 'uses')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="turnEditMode(false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span>{{amenitiesService.selectedItemData.buildingName || '-'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Unit</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span>{{amenitiesService.selectedItemData.suiteNumber || '-'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Resident</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span>{{amenitiesService.selectedItemData.residentFullName || '-'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs" *ngIf="amenitiesService.selectedItemData.managementOverride">
                        <div class="dv-label col-xs-4 col-md-4">
                            <label>Management Override</label>
                        </div>
                        <div class="dv-value col-xs-8 col-md-8 fourteenPixelText">
                            <i class="icon-check"></i>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Time From</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span>{{amenitiesService.selectedItemData.dateFrom | date:'dd.MM.yyyy hh:mm a':'+0000'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Time To</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span>{{amenitiesService.selectedItemData.dateTo | date:'dd.MM.yyyy hh:mm a':'+0000'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Created On</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span>{{amenitiesService.selectedItemData.createdAt ? (amenitiesService.selectedItemData.createdAt | mccDate:true:true) : '-'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Created By</label>
                        </div>
                        <div class="dv-value col-md-8">
                            <span>{{amenitiesService.selectedItemData.createdBy || '-'}}</span>
                        </div>
                    </div>

                    <!-- ___ Notes  ___ -->
                    <div class="row m-b-sm" *ngIf="!authenticationService.userIsResident">
                        <div class="dv-label col-xs-4 col-md-4">
                            <label>Notes</label>
                        </div>
                        <div class="col-xs-8 col-md-8">
                            <div class="mtv-primary-color" *ngIf="!noteEditMode"
                                 (click)="turnNoteEditMode(true)">
                                <span class="clickable">+Add Note</span>
                            </div>
                            <textarea class="form-control" *ngIf="noteEditMode"
                                      name="notes" [(ngModel)]="newNote" maxlength="255" required></textarea>
                        </div>
                    </div>

                    <div class="row m-b-sm" *ngIf="noteEditMode">
                        <div class="col-xs-4 col-md-4"></div>
                        <div class="col-xs-8 col-md-8 display-flex">
                            <div class="mtv-primary-color" (click)="addNote()" style="width: 50%">
                                <span class="clickable">Save Note</span>
                            </div>
                            <div class="text-align-right mtv-primary-color"
                                 (click)="turnNoteEditMode(false)" style="width: 50%">
                                <span class="clickable">Cancel</span>
                            </div>
                        </div>
                    </div>

                    <div class="row m-b-sm m-r-none" *ngFor="let note of amenitiesService.selectedItemData.notes">
                        <div class="col-xs-4 col-md-4"></div>
                        <div class="col-xs-8 col-md-8 notes">
                            <pre>{{note.noteText}}</pre>
                            <div class="notes-footer">
                                <div style="width: 50%">{{note.createdAt | mccDate:true:true}}</div>
                                <div class="text-align-right" style="width: 50%">
                                    {{note.createdBy ? note.createdBy.fullName : ''}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="navPosition == 'payment'" class="content parcel-modal">
                    <!--<div>-->
                        <!--<strong>Payment Method</strong> : {{getPaymentString()}}-->
                    <!--</div>-->
                    <amenities-payment></amenities-payment>
                </div>
                <div *ngIf="navPosition == 'history'" class="content">
                    <div class="text-center" style="color: red;">COMING SOON</div>
                    <div class="timeline">
                        <spinner [spinnerShow]="amenitiesService.historyLoading"></spinner>
                        <ul class="timeline__list" *ngIf="!amenitiesService.historyLoading">
                            <li *ngFor="let a of amenitiesService.history">
                                <section *ngIf="a.action !== 'ignore'">
                                    <header class="timeline__header">
                                    <span>
                                        <time>{{ a.loggedAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.userFullName }}
                                    </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div [ngSwitch]="a.action">

                                            <ng-template [ngSwitchCase]="'update'">
                                                {{ a.activityType }}
                                                <span class="timeline__active">"{{a.name}}"</span>
                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        {{ item?.key }} :
                                                        <span class="timeline__active">"{{ item?.old }}"</span>
                                                        changed to
                                                        <span class="timeline__active">"{{ item?.new }}"</span>
                                                    </li>
                                                </ul>
                                            </ng-template>

                                            <ng-template [ngSwitchCase]="'create'">
                                                <p>
                                                    {{ a.activityType }}
                                                    <span class="timeline__active">"{{a.name}}"</span>
                                                    was received
                                                </p>

                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        {{ item.key }} :
                                                        <span class="timeline__active">{{ item.value }}</span>
                                                    </li>
                                                </ul>
                                            </ng-template>

                                        </div>
                                    </main>
                                </section>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>

        <hr>

        <div class="btn-group dropup" style="width: 100%;">
            <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                Actions <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
                <li (click)="amenitiesService.approveBooking(amenitiesService.selectedItemData)"
                    *ngIf="amenitiesService.selectedItemData.isCanApprove &&
                                   amenitiesService.selectedItemData.status != 'approved' &&
                                   amenitiesService.selectedItemData.status != 'expired'">
                    <a>Approve</a>
                </li>
                <li *ngIf="amenitiesService.selectedItemData.isCanApprove &&
                                   (amenitiesService.selectedItemData.status == 'approved' ||
                                    amenitiesService.selectedItemData.status == 'pending')"
                    (click)="amenitiesService.declineBooking(amenitiesService.selectedItemData)">
                    <a>Decline</a>
                </li>
                <li *ngIf="amenitiesService.selectedItemData.isCanEdit &&
                                   (amenitiesService.selectedItemData.status == 'declined' ||
                                    amenitiesService.selectedItemData.status == 'pending')"
                    (click)="amenitiesService.editAmenity(amenitiesService.selectedItemData)">
                    <a>Edit</a>
                </li>
                <li *ngIf="amenitiesService.selectedItemData.isCanDelete"
                    (click)="amenitiesService.deleteAmenity(amenitiesService.selectedItemData.id)">
                    <a>Delete</a>
                </li>
                <li (click)="amenitiesService.viewAmenity(amenitiesService.selectedItemData)">
                    <a>View</a>
                </li>
                <!--<li *ngIf="amenitiesService.bookingHasPayments(amenitiesService.selectedItemData) &&-->
                                   <!--amenitiesService.selectedItemData.isCanEdit"-->
                    <!--(click)="amenitiesService.showPaymentModal(amenitiesService.selectedItemData)">-->
                    <!--<a>Pay</a>-->
                <!--</li>-->
            </ul>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-detailed-view/amenities-detailed-view.component.html